<template>
  <div class="patentSearch contentBack">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>专利管理</el-breadcrumb-item>
      <el-breadcrumb-item class="breadSelected">专利查询 </el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <div class="listTitle titleBold gjcx">
        高级查询
        <span @click="handlegjcxShow">[展开/收起]</span>
      </div>

      <div class="gjcxContent" v-if="gjcxShow">
        <el-form
          ref="form"
          :model="form"
          label-width="82px"
          label-position="left"
        >
          <!-- 第一行 -->
          <div style="display: flex; justify-content: space-between">
            <el-form-item class="elform30" label="申请人：" size="mini">
              <el-input
                v-model="form.ap"
                placeholder="输入申请人名称"
                prefix-icon="el-icon-search"
                @change="applicantSearch()"
              >
                <!-- <el-option
                      v-for="item in applicantField"
                      :key="item.label"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option> -->
              </el-input>
            </el-form-item>
            <!-- 模糊查询结果 -->
            <div class="startFirms-new" v-if="startFirms">
              <ul>
                <li
                  v-for="(item, index) of firms"
                  :key="index"
                  @click="chooseKeyfirm(index)"
                >
                  {{ item.ap }}
                </li>
              </ul>
            </div>
            <el-form-item class="elform30" label="专利号：" size="mini">
              <el-input v-model="form.an" placeholder="输入专利号"></el-input>
            </el-form-item>
            <el-form-item class="elform30" label="公开号：" size="mini">
              <el-input v-model="form.pan" placeholder="输入公开号"></el-input>
            </el-form-item>
          </div>
          <!-- 第二行 -->
          <div style="display: flex; justify-content: space-between">
            <el-form-item class="elform30" label="专利名称：" size="mini">
              <el-input
                v-model="form.name"
                placeholder="输入专利名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请日：" size="mini" style="width: 30%">
              <el-row>
                <!-- span的值为24 -->
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.sapd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
                <el-col :span="2"> 至 </el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.eapd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="公开日：" size="mini" style="width: 30%">
              <el-row>
                <!-- span的值为24 -->
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.spd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
                <el-col :span="2"> 至 </el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.epd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </div>

          <!-- 第三行 -->
          <div style="display: flex; justify-content: space-between">
            <el-form-item label="授权日：" size="mini" style="width: 30%">
              <el-row>
                <!-- span的值为24 -->
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.sad"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
                <el-col :span="2"> 至 </el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.ead"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item label="IPC分类：" style="width: 30%">
              <el-cascader
                v-model="ipcValue"
                :options="options"
                :props="{ expandTrigger: 'click' }"
                @change="changeIPC"
               
                @expand-change="getIPC2"
                style="margin-left: 0; display: flex"
                popper-class="mycascader"
              ></el-cascader>
            </el-form-item>

            <el-form-item label="LOC分类：" style="width: 30%">
              <el-cascader
                v-model="locValue"
                :options="options2"
                :props="{ expandTrigger: 'click' }"
                @change="changeLOC"
               
                @expand-change="getLoc2"
                style="margin-left: 0; display: flex"
                placement="bottom-end"
                popper-class="mycascader"
              ></el-cascader>
            </el-form-item>
          </div>
          <!-- 第四行 -->
          <div style="display: flex; ">
            <!-- <el-form-item label="重点产业：" style="width: 30%">
              <el-select v-model="form.zdcy" style="display: flex">
                <el-option label="全部" value="全部产业"></el-option>
                <el-option label="电子信息" value="电子信息"></el-option>
                <el-option label="装备制造" value="装备制造"></el-option>
                  <el-option label="生物医药" value="生物医药"></el-option>
                <el-option label="能源化工" value="能源化工"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="行业分类：" style="width: 30%">
              <el-select v-model="form.hyfl" style="display: flex">
                    <el-option
                  label="全部分类"
                  value="全部行业"
                ></el-option>
                <el-option
                  label="交通运输、仓储和邮政业"
                  value="交通运输、仓储和邮政业"
                ></el-option>
                <el-option
                  label="住宿和餐饮业"
                  value="住宿和餐饮业"
                ></el-option>
                <el-option
                  label="信息传输、软件和信息技术服务业"
                  value="信息传输、软件和信息技术服务业"
                ></el-option>
                <el-option
                  label="公共管理、社会保障和社会组织"
                  value="公共管理、社会保障和社会组织"
                ></el-option>
                <el-option
                  label="农、林、牧、渔业"
                  value="农、林、牧、渔业"
                ></el-option>
                <el-option label="制造业" value="制造业"></el-option>
                <el-option
                  label="卫生和社会工作"
                  value="卫生和社会工作"
                ></el-option>
                <el-option
                  label="居民服务、修理和其他服务业"
                  value="居民服务、修理和其他服务业"
                ></el-option>
                <el-option label="建筑业" value="建筑业"></el-option>
                <el-option label="房地产业" value="房地产业"></el-option>
                <el-option
                  label="批发和零售业"
                  value="批发和零售业"
                ></el-option>
                <el-option label="教育" value="教育"></el-option>
                <el-option
                  label="文化、体育和娱乐业"
                  value="文化、体育和娱乐业"
                ></el-option>
                <el-option
                  label="水利、环境和公共设施管理业"
                  value="水利、环境和公共设施管理业"
                ></el-option>
                <el-option
                  label="电力、热力、燃气及水生产和供应业"
                  value="电力、热力、燃气及水生产和供应业"
                ></el-option>
                <el-option
                  label="租赁和商务服务业"
                  value="租赁和商务服务业"
                ></el-option>
                <el-option label="采矿业" value="采矿业"></el-option>
                <el-option label="金融业" value="金融业"></el-option>
                <el-option
                  label="科学研究和技术服务业"
                  value="科学研究和技术服务业"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="elform30" label="专利数量：" size="mini" style="margin-left: 5%;">
              <el-input
                style="width: 45%"
                v-model="form.patentNumSrt"
                placeholder="请输入数字"
              ></el-input>
              至
              <el-input
                style="width: 45%"
                v-model="form.patentNumEnd"
                placeholder="请输入数字"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 选择区域 -->
          <el-form-item label="企业分类：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll1"
                @change="handleCheckAllChange1"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.apType"
                @change="handleCheckedCompanyChange1"
              >
                <el-checkbox label="规上企业" name="apType"></el-checkbox>
                <el-checkbox label="专精特新企业" name="apType"></el-checkbox>
                <el-checkbox label="高新技术企业" name="apType"></el-checkbox>
                <el-checkbox label="融合发展企业" name="apType"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>

          <el-form-item label="专利类型：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll2"
                @change="handleCheckAllChange2"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.type"
                @change="handleCheckedCompanyChange2"
              >
                <el-checkbox label="1" name="type">发明</el-checkbox>
                <el-checkbox label="2" name="type">实用新型</el-checkbox>
                <el-checkbox label="3" name="type">外观设计</el-checkbox>
                <el-checkbox label="8" name="type">PCT专利</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="法律状态：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll3"
                @change="handleCheckAllChange3"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.ls"
                @change="handleCheckedCompanyChange3"
              >
                <el-checkbox label="30" name="ls">在审</el-checkbox>
                <el-checkbox label="10" name="ls">有效</el-checkbox>
                <el-checkbox label="20" name="ls">无效</el-checkbox>
                <el-checkbox label="11" name="ls">部分有效</el-checkbox>
                <el-checkbox label="21" name="ls">专利权届满</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="申请人类型：" class="sqrlx">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll4"
                @change="handleCheckAllChange4"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.apt"
                @change="handleCheckedCompanyChange4"
              >
                <el-checkbox label="1" name="apt">工矿企业</el-checkbox>
                <el-checkbox label="2" name="apt">科研单位</el-checkbox>
                <el-checkbox label="3" name="apt">大专院校</el-checkbox>
                <el-checkbox label="4" name="apt">机关团体</el-checkbox>
                <el-checkbox label="5" name="apt">个人</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="行政区域：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll5"
                @change="handleCheckAllChange5"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.area"
                @change="handleCheckedCompanyChange5"
              >
                <el-checkbox
                  v-for="(region, index) of regions"
                  :key="index"
                  :label="region"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="战略新兴产业分类：" label-width="130px">
            <div style="display: flex">
              <el-checkbox v-model="checkAll6" @change="handleCheckAllChange6"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.StrategicNew"
                @change="handleCheckedCompanyChange6"
              >
                <el-checkbox
                  label="新一代信息技术产业"
                  name="apty"
                ></el-checkbox>
                <el-checkbox label="新材料产业" name="apty"></el-checkbox>
                <el-checkbox label="生物产业" name="apty"></el-checkbox>
                <el-checkbox label="新能源产业" name="apty"></el-checkbox>
                <el-checkbox label="数字创意产业" name="apty"> </el-checkbox>
                <el-checkbox label="高端装备制造产业" name="apty"></el-checkbox>
                <el-checkbox label="新能源汽车产业" name="apty"></el-checkbox>
                <el-checkbox label="节能环保产业" name="apty"></el-checkbox>
                <el-checkbox label="相关服务业" name="apty"> </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="高价值专利分类：" label-width="130px">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll7"
                @change="handleCheckAllChange7"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.highValue"
                @change="handleCheckedCompanyChange7"
              >
                <el-checkbox label="Strategic_new" name="gjty"
                  >战略性新兴产业的发明专利</el-checkbox
                >
                <el-checkbox label="Overseas_Coaxial" name="gjty"
                  >在海外有同族专利权</el-checkbox
                >
                <el-checkbox label="Long_life" name="gjty"
                  >维持年限超过10年</el-checkbox
                >
                  <el-checkbox label="Pledge_financing" name="gjty" 
                    >实现较高质押融资金额</el-checkbox
                  >
                   <el-checkbox label="Patent_Award" name="gjty"
                    >获得国家科学技术奖或中国专利奖
                  </el-checkbox>
                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="无法选择该内容，由于该项指标数据不全无法精确判定"
                  placement="bottom"
                >
                  <el-checkbox label="Pledge_financing" name="gjty" disabled
                    >实现较高质押融资金额</el-checkbox
                  >
                </el-tooltip> -->
                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="无法选择该内容，由于该项指标数据不全无法精确判定"
                  placement="bottom"
                >
                  <el-checkbox label="Patent_Award" name="gjty" disabled
                    >获得国家科学技术奖或中国专利奖
                  </el-checkbox>
                </el-tooltip> -->
              </el-checkbox-group>
            </div>
          </el-form-item>
          <!-- 按钮 -->
          <el-form-item label-width="0">
            <el-button
              style="background: #1890ff; padding: 10px 24px"
              type="primary"
              @click="onSubmit2"
              >查 询</el-button
            >
            <el-button
              style="padding: 10px 24px; margin-left: 46px"
              @click="resetData"
              >重 置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 查询结果 -->
      <div v-if="isSearch">
        <div class="listTitle titleBold gjcx">
          查询结果 <div style="margin-left:14px;">注：专利、申请人地址均在乐山</div>
          <div class="out-excel" style="flex: 1">
            <el-button
              style="
                float: right;
                margin-right: 20px;
                height: 30px;
                line-height: 30px;
                padding: 0 16px;
                border-radius: 2px;
                margin-top: 5px;
                border: 1px solid #1773d5;
                color: #1773d5;
              "
              @click="daochu"
              >导出全部</el-button
            >
            <el-button
              style="
                float: right;
                margin-right: 20px;
                height: 30px;
                line-height: 30px;
                padding: 0 16px;
                border-radius: 2px;
                margin-top: 5px;
                border: 1px solid #1773d5;
                color: #1773d5;
              "
              @click="daochu"
              >导出已选</el-button
            >
          </div>
        </div>
        <div class="cxResultContent">
          <!-- 数据汇总 -->
          <!-- 专利xx件。 授权专利xx件（发明授权专利xx件。实用新型授权专利xx件。外观设计授权专利xx件）。 累计有效专利xx件。PCT申请专利xx件。 -->
          <table></table>
          <div style="margin: 11px 20px; font-size: 14px; color: #000">
            查询结果中
<!--            ，申请人共<span class="bloooo">{{-->
<!--              dataSummary.apTotal-->
<!--            }}</span>-->
<!--            个-->
            ，专利共<span class="bloooo">{{ dataSummary.total }}</span
            >件,授权专利<span class="bloooo">{{ dataSummary.ptAuth }}</span
            >件（授权发明专利<span class="bloooo">{{
              dataSummary.ptInvention
            }}</span
            >件，授权实用新型专利<span class="bloooo">{{
              dataSummary.ptUtility
            }}</span
            >件，授权外观设计专利<span class="bloooo">{{
              dataSummary.ptOutlook
            }}</span
            >件）。累计有效专利<span class="bloooo">{{
                  dataSummary.ptValid || "0"
                }}</span
                >件，PCT申请专利<span class="bloooo">{{ dataSummary.pct }}</span
            >件。
          </div>
          <el-table
            ref="multipleTable1"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            border
            @sort-change="sort"
          >
            <!-- 选择框 -->
            <el-table-column :resizable="false" type="selection" width="40">
            </el-table-column>
            <!-- 序号 -->
            <el-table-column
              :resizable="false"
              label="序号"
              type="index"
              width="50"
            >
              <template slot-scope="scope">
                <span>{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
              </template></el-table-column
            >
            <!-- 申请号 -->
            <el-table-column
              :resizable="false"
              prop="sPatentnumber"
              label="申请号"
              width="150"
            >
              <template slot-scope="scope">
                <div class="apStyle" @click="openDetails(scope.row)">
                  {{ scope.row.sPatentnumber }}
                </div>
              </template>
            </el-table-column>
            <!-- 专利名称 -->
            <el-table-column
              :resizable="false"
              prop="sTitle"
              label="专利名称"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <!-- 申请人 -->
            <el-table-column
              :resizable="false"
              prop="sProposer1st"
              label="申请人"
              show-overflow-tooltip
            ></el-table-column>
            <!-- 专利类型 -->
            <el-table-column
              :resizable="false"
              prop="sPatenttype"
              label="专利类型"
              min-width="75"
            >
            </el-table-column>
          
                  <!-- 高价值专利指标  -->
            <el-table-column
              :resizable="false"
             prop="strategicNew,overseasCoaxial,patentAward,longLife,pledgeFinancing"
             
              label="高价值专利指标"
              min-width="140"
            >
             <template slot-scope="scope">
                    <span>
                      {{ scope.row.strategicNew }}
                      {{ scope.row.overseasCoaxial }}
                      {{ scope.row.patentAward }}
                      {{ scope.row.longLife }}
                      {{ scope.row.pledgeFinancing }}
                      
                    </span>
                  </template></el-table-column>
           
            <!-- 公开号 -->
            <el-table-column
              :resizable="false"
              prop="sPubnumber"
              label="公开号"
              min-width="90"
              show-overflow-tooltip
            ></el-table-column>
               <!-- 申请日 -->
            <el-table-column
              :resizable="false"
              prop="dtApplydate"
              sortable="custom"
              label="申请日"
              min-width="90"
            ></el-table-column>
            <!-- 公开日 -->
            <el-table-column
              :resizable="false"
              prop="dtPubdate"
              sortable="custom"
              label="公开日"
              min-width="90"
            ></el-table-column>
            <!-- 授权日 -->
            <el-table-column
              :resizable="false"
              prop="dtAuthdate"
              sortable="custom"
              label="授权日"
              min-width="90"
            ></el-table-column>
               <!-- 终止日 -->
            <el-table-column
              :resizable="false"
              prop="dtEnddate"
             
              label="终止日"
              min-width="90"
            ></el-table-column>
            <!-- 法律状态 -->
            <el-table-column
              :resizable="false"
              prop="sLawmark"
              label="法律状态"
              min-width="75"
            ></el-table-column>
            <!-- IPC分类/LOC分类 -->
            <el-table-column
              :resizable="false"
              prop="sMainipc"
              label="IPC分类/LOC分类"
              min-width="130"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <div v-if="isSearch" class="page-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dataSummary.total"
        >
        </el-pagination>
        <el-button size="mini" type="primary" style="margin-left: 5px"
          >确定</el-button
        >
      </div>
      <!-- 专利基本信息弹框 -->

      <!-- 专利基本信息弹框结束 -->
    </div>
  </div>
</template>
<script>
export default {
  name: "patSearch",
  data() {
    return {
      startFirms: false, //模糊查询结果
      firms: [],

      gjcxShow: true,
      form: {
        ap: "", //申请人名
        an: "", //专利申请号
        pan: "", //公开号
        name: "", // 专利名
        sapd: "", // 申请日1
        eapd: "", //申请日2
        spd: "", //公开日1
        epd: "", //公开日2
        sad: "", //授权日1
        ead: "", //授权日2
        ipc: "", //IPC分类
        loc: "", //LOC分类
        apType: [], //企业分类
        area: [], //行政区域
        zdcy: "", //重点产业
        hyfl: "", //行业分类
        apt: [], //申请人类型
        type: [], //专利类型
        ls: [], // 法律状态
         //专利数量
        
        patentNumSrt:'',
        patentNumEnd:'',
        
        StrategicNew: [], //战略新兴产业
        highValue: [], //高价值专利
      },
      typeFirm: [
        "高新技术企业",
        "规上企业",
        "重点企业",
        "专精特新企业",
        "融合发展企业",
      ],
      Ptype: ["1", "2", "3", "8"],
      lawtype: ["30", "10", "20", "11", "21"],
      applytype: ["1", "2", "3", "4", "5"],
      zhanluetype: [
        "新一代信息技术产业",
        "新材料产业",
        "生物产业",
        "新能源产业",
        "数字创意产业",
        "高端装备制造产业",
        "新能源汽车产业",
        "节能环保产业",
        "相关服务业",
      ],
      gjzzltype: ["Strategic_new", "Overseas_Coaxial", "Long_life","Pledge_financing","Patent_Award"],
      regions: [],
      options: [
          {
          value: "",
          label: ""},
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
      ],
      options2: [
         {
          value: "",
          label: ""
          } ,
        
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
      ],
      ipcValue: [],
      locValue: [],
      checkAll1: false,
      checkAll2: false,
      checkAll3: false,
      checkAll4: false,
      checkAll5: false,
      checkAll6: false,
      checkAll7: false,
      order: "",
      orderType: "", //排序方式
      pageNum: 1,
      pageSize: 10,
      isSearch: false,
      //   数据汇总
      dataSummary: [],
      tableData: [],
      currentPage: 1,
      total: 0,
      multipleSelection: [],
      // zldetails: false,
      zlbasicDataDetails: [],
    };
  },
  methods: {
    // 申请人模糊查询
    applicantSearch() {
      this.$GET("applicant/searchField", {
        keyword: this.form.ap,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.firms = res.data.list;
        if (this.firms.length === 0) {
          this.startFirms = false;
        } else {
          this.startFirms = true;
        }
      });
    },
    chooseKeyfirm(index) {
      this.form.ap = this.firms[index].ap;
      this.startFirms = false;
    },
    handlegjcxShow() {
      this.gjcxShow = this.gjcxShow ? false : true;
    },
    // 选择企业分类
    handleCheckedCompanyChange1(value) {
      this.checkAll1 = value.length == this.typeFirm.length;
    },
    handleCheckAllChange1(value) {
      value ? (this.form.apType = this.typeFirm) : (this.form.apType = []);
    },
    // 选择专利类型
    handleCheckedCompanyChange2(value) {
      this.checkAll2 = value.length == this.Ptype.length;
    },
    handleCheckAllChange2(value) {
      value ? (this.form.type = this.Ptype) : (this.form.type = []);
    },
    // 选择法律状态
    handleCheckedCompanyChange3(value) {
      this.checkAll3 = value.length == this.lawtype.length;
    },
    handleCheckAllChange3(value) {
      value ? (this.form.ls = this.lawtype) : (this.form.ls = []);
    },
    // 选择申请人类型
    handleCheckedCompanyChange4(value) {
      this.checkAll4 = value.length == this.applytype.length;
    },
    handleCheckAllChange4(value) {
      value ? (this.form.apt = this.applytype) : (this.form.apt = []);
    },
    // 选择行政区域
    handleCheckedCompanyChange5(value) {
      this.checkAll5 = value.length == this.regions.length;
      this.form.area = value;
    },
    handleCheckAllChange5(value) {
      value ? (this.form.area = this.regions) : (this.form.area = []);
    },
    // 选择战略新兴区域
    handleCheckedCompanyChange6(value) {
      // console.log('.....',value)
      // if(indexOf('新一代信息技术产业'))
      this.checkAll6 = value.length == this.zhanluetype.length;
    },
    handleCheckAllChange6(value) {
      value
        ? (this.form.StrategicNew = this.zhanluetype)
        : (this.form.StrategicNew = []);
    },
    // 选择高价值分类区域
    handleCheckedCompanyChange7(value) {
      this.checkAll7 = value.length == this.gjzzltype.length;
    },
    handleCheckAllChange7(value) {
      value ? (this.form.highValue = this.gjzzltype) : (this.form.highValue = []);
    },
    // 查询和重置
    onSubmit2() {
      this.dataSummary = [];
      this.multipleSelection = [];
      this.currentPage = 1;
      this.pageNum = 1;
      this.pageSize = 10;
      if (this.order != "") {
        this.resetSort();
        this.$refs.multipleTable1.clearSort();
      }
      this.onSubmit();
    },
    onSubmit() {
      this.$GET("/patent/list", {
        type: this.form.type.join(";"),
        apt: this.form.apt.join(";"),
        ls: this.form.ls.join(";"),
        apType: this.form.apType.join(";"),
        zdcy: this.form.zdcy,
        hyfl:this.form.hyfl,
        ap: this.form.ap,
        an: this.form.an,
        pan: this.form.pan,
        name: this.form.name,
        sapd: this.form.sapd,
        eapd: this.form.eapd,
        spd: this.form.spd,
        epd: this.form.epd,
        sad: this.form.sad,
        ead: this.form.ead,
        ipc: this.form.ipc,
        loc: this.form.loc,
        area: this.form.area.join(";"),
        order: this.order,
        orderType: this.orderType,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        patentNumSrt:this.form.patentNumSrt,
        patentNumEnd:this.form.patentNumEnd,
        // 战略新兴
        StrategicNew: this.form.StrategicNew.join(";"),
        highValue: this.form.highValue.join(";"),
      }).then((res) => {
        this.isSearch = true;
        this.gjcxShow = false;
        if (this.dataSummary.length == 0) {
          this.dataSummary = res.data.count;
        }
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
        this.tableData.forEach((ele) => {
          if (ele.sPatenttype == "1") {
            ele.sPatenttype = "发明";
          } else if (ele.sPatenttype == "2") {
            ele.sPatenttype = "实用新型";
          } else if (ele.sPatenttype == "3") {
            ele.sPatenttype = "外观设计";
          } else if (ele.sPatenttype == "8") {
            ele.sPatenttype = "PCT发明";
          } else if (ele.sPatenttype == "9") {
            ele.sPatenttype = "PCT实用新型";
          }
          if (ele.dtApplydate !== null) {
            ele.dtApplydate = ele.dtApplydate.split(" ")[0];
          }
          if (ele.dtPubdate !== null) {
            ele.dtPubdate = ele.dtPubdate.split(" ")[0];
          }
          if (ele.dtAuthdate !== null) {
            ele.dtAuthdate = ele.dtAuthdate.split(" ")[0];
          }
          if (ele.sLawmark == "10") {
            ele.sLawmark = "有效";
          } else if (ele.sLawmark == "11") {
            ele.sLawmark = "部分有效";
          } else if (ele.sLawmark == "20") {
            ele.sLawmark = "无效";
          } else if (ele.sLawmark == "30") {
            ele.sLawmark = "在审";
          } else if (ele.sLawmark == "21" || ele.sLawmark == "22") {
            ele.sLawmark = "专利权届满";
          }

          if (ele.longLife == "是") {
            ele.longLife = "维持年限超10年";
          } 
            if (ele.strategicNew == "是") {
            ele.strategicNew = "战新产业";
          } 
            if (ele.overseasCoaxial == "是") {
            ele.overseasCoaxial = "海外同族";
          } 
            if (ele.patentAward == "是") {
          ele.patentAward = "获奖";
          }
          if (ele.pledgeFinancing == "是") {
              ele.pledgeFinancing = "较高质融";
            }
                   
        });
      });
    },
    resetData() {
      (this.form.StrategicNew = []),
      (this.form.highValue = []),
      (this.form.ap = ""); //申请人名
      this.form.an = ""; //专利申请号
      this.form.pan = ""; //公开号
      this.form.name = ""; // 专利名
      this.form.sapd = ""; // 申请日1
      this.form.eapd = ""; //申请日2
      this.form.spd = ""; //公开日1
      this.form.epd = ""; //公开日2
      this.form.sad = ""; //授权日1
      this.form.ead = ""; //授权日2
      this.form.ipc = ""; //IPC分类
      this.form.loc = ""; //LOC分类
      this.form.apType = []; //企业分类
      this.checkAll1= false;
      this.checkAll2= false;
      this.checkAll3= false;
      this.checkAll4= false;
      this.checkAll5= false;
      this.checkAll6= false;
      this.checkAll7= false;
      this.form.area = []; //行政区域
      this.form.zdcy = ""; //重点产业
      this.form.apt = []; //申请人类型
      this.form.type = []; //专利类型
      this.form.ls = []; // 法律状态
      this.ipcValue = [];
      this.locValue = [];
      this.form.hyfl = "";
      this.form.patentNumSrt ='';
      this.form.patentNumEnd=''

    },
    // 选择IPC和IOC
    getIPC() {
      this.$get("/patent/ipcbp", {
        token: localStorage.getItem("token"),
        pid: "",
      }).then((res) => {
        let ipcOptions = res.data;
        // console.log('ipcOptions',ipcOptions)
        let ipc = [];
        let ipcCode = [];
        ipc.push('全部分类')
        ipcCode.push('')
        ipcOptions.forEach((ele) => {
          ele.name = ele.code + "-" + ele.name;
          ipc.push(ele.name);
          ipcCode.push(ele.code);
        });
       
        this.options.forEach((item, index) => {
     
          ipc.forEach((ele, index) => {
            this.options[index].label = ipc[index];
          });
          ipcCode.forEach((element, index) => {
            this.options[index].value = ipcCode[index];
          });
        });
      });
    },
    getIPC2(value) {
      
      let pid = value[0];
      this.$get("/patent/ipcbp", {
        token: localStorage.getItem("token"),
        pid: pid,
      }).then((res) => {
        let ipcs = res.data;
        ipcs.forEach((ele) => {
          ele.label = ele.code + "-" + ele.name;
          ele.value = ele.code + "-" + ele.name;
          delete ele.code;
          delete ele.name;
        });
        this.options.forEach((ele, index) => {
          if (this.options[index].value == pid) {
            this.options[index].children = ipcs;
          }
        });
      });
    },
    getLoc() {
      this.$get("/patent/locbp", {
        token: localStorage.getItem("token"),
        pid: "",
      }).then((res) => {
        let locOptions = res.data;
        let loc = [];
        let locCode = [];
        loc.push('全部分类')
        locCode.push('')
        locOptions.forEach((ele) => {
          ele.name = ele.code + "-" + ele.name;
          loc.push(ele.name);
          locCode.push(ele.code);
        });
        this.options2.forEach((item, index) => {
          loc.forEach((ele, index) => {
            this.options2[index].label = loc[index];
          });
          locCode.forEach((element, index) => {
            this.options2[index].value = locCode[index];
          });
        });
      });
    },
    getLoc2(value) {
      let pid = value[0];
      this.$get("/patent/locbp", {
        token: localStorage.getItem("token"),
        pid: pid,
      }).then((res) => {
        let ipcs = res.data;
        ipcs.forEach((ele) => {
          ele.label = ele.code + " " + ele.name;
          ele.value = ele.code + " " + ele.name;
          delete ele.code;
          delete ele.name;
        });
        this.options2.forEach((ele, index) => {
          if (this.options2[index].value == pid) {
            this.options2[index].children = ipcs;
          }
        });
      });
    },
    changeIPC(value) {
      // console.log('value2',value)
      if(value[0] == ''){
        this.form.ipc=''
      } else {
        let ipc = value[1].split("-")[0];
      this.form.ipc = ipc;
      }
      // if(value[0])
      // let ipc = value[1].split("-")[0];
      // console.log('----',ipc)
      // this.form.ipc = ipc;
    },
    changeLOC(value) {
      // console.log('value',value)
       if(value[0] == ''){
        this.form.loc=''
      } else {
       let loc = value[1].split(" ")[0];
      this.form.loc = loc;
      }
      // let loc = value[1].split(" ")[0];
      // this.form.loc = loc;
    },
    // 导出
    daochu() {
      if (this.multipleSelection.length > 0) {
        var ans = [];
        this.multipleSelection.forEach((ele) => {
          ans.push(ele.sPatentnumber);
        });
        // 通过a 标签导出
        let aLink1 = document.createElement("a");
        let an = ans.join(";");
        aLink1.href =
          this.$url +
          "/patent/et?token=" +
          localStorage.getItem("token") +
          "&uid=" +
          localStorage.getItem("uid") +
          "&ans=" +
          an;
        aLink1.click();
      } else if (this.multipleSelection.length == 0) {
        let StrategicNew = this.form.StrategicNew.join(";");
        let highValue = this.form.highValue.join(";");
        // console.log('highValue',highValue)
        let apType = this.form.apType.join(";");
        let area = this.form.area.join(";");
        let apt = this.form.apt.join(";");
        let type = this.form.type.join(";");
        let ls = this.form.ls.join(";");
     
        let aLink2 = document.createElement("a");
        // let an = ans.join(";");
        aLink2.href =
          this.$url +
          "/patent/et?token=" +
          localStorage.getItem("token") +
          "&uid=" +
          localStorage.getItem("uid") +
          "&ap=" +
          this.form.ap +
          "&an=" +
          this.form.an +
          "&pan=" +
          this.form.pan +
          "&name=" +
          this.form.name +
          "&sapd=" +
          this.form.sapd +
          "&eapd=" +
          this.form.eapd +
          "&spd=" +
          this.form.spd +
          "&epd=" +
          this.form.epd +
          "&sad=" +
          this.form.sad +
          "&ead=" +
          this.form.ead +
          "&ipc=" +
          this.form.ipc +
          "&loc=" +
          this.form.loc +
          "&zdcy=" +
          this.form.zdcy +
          "&hyfl=" +
          this.form.hyfl +
          "&apType=" +
          apType +
           "&StrategicNew=" +
          StrategicNew +
          "&highValue=" +
          highValue +
          "&area=" +
          area +
          "&apt=" +
          apt +
          "&type=" +
          type +
          "&ls=" +
          ls;
        aLink2.click();
      }
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 排序
    sort(column) {
      // console.log('column',column)
      if (column.prop == "dtPubdate") {
        this.order = "pd";
      }
      if (column.prop == "dtAuthdate") {
        this.order = "ad";
      }
      if (column.prop == "dtApplydate") {
        this.order = "apd";
      }
      let orderType;
      if (column.order == "ascending") {
        orderType = "asc";
      } else if (column.order == "descending") {
        orderType = "desc";
      }
      this.orderType = orderType;
      this.onSubmit();
    },
    // 分页
    handleSizeChange(value) {
      this.pageSize = value;
      this.onSubmit();
    },
    handleCurrentChange(value) {
      this.pageNum = value;
      this.onSubmit();
    },
    // 打开专利详请弹框
    openDetails(row) {
      this.$router.push({
        path: "/PatentSearchInfo",
      });
      this.zlbasicDataDetails = row;
      this.$store.commit("zlDataDetails", this.zlbasicDataDetails);
    },
    // closeTkZl() {
    //   this.zldetails = false;
    // },
    resetSort() {
      this.$refs.multipleTable1.sort(this.order, null);
    },
  },
  created() {
// 加载IPC分类和loc分类
    // this.getIPC()
    // this.getLoc()
  },
  mounted() {
    let regions = JSON.parse(localStorage.getItem("DataPermission"));
    let regionName = [];
    regions.forEach((element) => {
      regionName.push(element.name);
    });
    this.regions = regionName;
    // 加载IPC分类和loc分类
    this.getIPC()
    this.getLoc()
  },
};
</script>
<style>
.patentSearch > div {
  height: 100%;
  overflow-y: auto;
}
.patentSearch .el-form--label-left .el-form-item__label {
  text-align: right;
}
.patentSearch .el-form-item__label {
  padding: 0;
}
.patentSearch .sqrlx .el-form-item__label {
  width: 86px !important;
}
.patentSearch .el-form-item:not(.el-form-item--mini) {
  margin-bottom: 0;
}
.mycascader .el-cascader-menu__list {
  max-width: 13vw !important;
}
.patentSearch .gjcxContent .el-form-item__content {
  text-align: center;
}
</style>